import Vue from "vue"
import VueRouter from "vue-router";
import Dashboard from "../components/dashboard/dashboard";
import Trip from "../components/trip/trip";
import Login from "../components/security/login";
import Register from "../components/security/register";
import Home from "../components/home";
import ContactUs from "../components/contacts/contact_us";
import Trips from "../components/trip/trips";
import ResetPassword from "../components/security/reset-password";
import ChangePassword from "../components/security/change-password";
import TripReports from "../components/trip/trip_reports";
import store from "../store";


Vue.use(VueRouter);


//Weird, doing it like this cause for openauth cant do serverside redirects to client side routing
const requiresAuth = (noAuth) => {

    return (to, from, next) =>{

        store.dispatch("getUserProfile", () => {
            if(!store.state.globalStore.user.email) {
                if(noAuth) {
                    next();
                }else {
                    next({
                        path: "/login",
                        query: {redirect: to.fullPath}
                    });
                }

            }else  {
                next();
            }
        });
    }
}

const routes = [
    {path: "/login", component: Login },
    {path: "/register", component: Register},
    {path: '/dashboard', component: Dashboard, beforeEnter: requiresAuth()},
    {path: '/home', component: Home},
    {path: '/trips/:code', component: Trip, beforeEnter: requiresAuth()},
    {path: '/trips', component: Trips, beforeEnter: requiresAuth()},
    {path: '/contact-us', component: ContactUs, beforeEnter: requiresAuth(true)},
    {path: '/reset-password', component: ResetPassword},
    {path: '/change-password/:base64Email', component: ChangePassword},
    {path: '/trip-reports', component: TripReports, beforeEnter: requiresAuth()},
    {path: '/', component: Home, beforeEnter: requiresAuth(true)},
]

const router = new VueRouter({
    routes
});

export default router
